import React, { useCallback, useEffect, useState } from 'react';
import axiosInstance from '../../utils/axiosConfig';
import RandevuFormModal from './RandevuFormModal';
import { RandevuOzet, RandevuVarsayilan, durumMeta, aktifDurum, tarihOku, saatAraligi, randevuAc, RANDEVU_DEGISTI_OLAYI } from './randevuOrtak';
import '../takip/takip.css';
import './randevu.css';

// Müşteri / potansiyel müşteri / proje sayfalarındaki "Randevu" düğmesi: kayda bağlı randevular + yeni randevu
interface Props {
    tur: 'CARI' | 'LEAD' | 'PROJE';
    id: number | null | undefined;
    ad: string;
    style?: React.CSSProperties;
}

const KayitRandevuButonu: React.FC<Props> = ({ tur, id, ad, style }) => {
    const [liste, setListe] = useState<RandevuOzet[] | null>(null);
    const [acik, setAcik] = useState(false);
    const [yeni, setYeni] = useState(false);
    const [gecmis, setGecmis] = useState(false);

    const yukle = useCallback(async () => {
        if (!id) return;
        const params = tur === 'CARI' ? { cariID: id } : tur === 'LEAD' ? { leadID: id } : { projeID: id };
        try { const r = await axiosInstance.get('/api/Randevular', { params }); setListe(r.data); }
        catch { setListe([]); }
    }, [tur, id]);
    useEffect(() => { yukle(); }, [yukle]);
    useEffect(() => {
        window.addEventListener(RANDEVU_DEGISTI_OLAYI, yukle);
        return () => window.removeEventListener(RANDEVU_DEGISTI_OLAYI, yukle);
    }, [yukle]);

    if (!id) return null;
    const simdi = new Date();
    const yaklasan = (liste ?? []).filter(r => aktifDurum(r.durum) && tarihOku(r.bitis) >= simdi);
    const digerleri = (liste ?? []).filter(r => !yaklasan.includes(r)).reverse();
    const varsayilan: RandevuVarsayilan = tur === 'CARI' ? { cari: { id, ad } } : tur === 'LEAD' ? { lead: { id, ad } } : { projeID: id };

    const satir = (r: RandevuOzet) => {
        const dm = durumMeta(r.durum);
        return (
            <div key={r.randevuID} className="tkp-kart" style={{ background: '#f8fafc', borderLeft: `4px solid ${r.renk}` }} onClick={() => randevuAc(r.randevuID)}>
                <div className="tkp-kart-icerik">
                    <div className="tkp-kart-baslik">{r.baslik}</div>
                    <div className="tkp-kart-meta">
                        <span className="tkp-rozet notr"><i className="fas fa-calendar-day"></i>{tarihOku(r.baslangic).toLocaleDateString('tr-TR', { day: 'numeric', month: 'short', year: 'numeric', weekday: 'short' })} {saatAraligi(r)}</span>
                        <span className="rnd-durum" style={{ background: dm.zemin, color: dm.renk }}>{dm.ad}</span>
                        {r.personelAdi && <span><i className="fas fa-user"></i>{r.personelAdi}</span>}
                        {tur === 'PROJE' && r.musteriAdi && <span><i className="fas fa-user-tie"></i>{r.musteriAdi}</span>}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <button type="button" className="tkp-kayit-btn" style={{ borderColor: '#0d9488', color: '#0f766e', background: '#f0fdfa', ...style }} onClick={() => setAcik(true)} title="Randevular">
                <i className="fas fa-calendar-check"></i>Randevu
                {yaklasan.length > 0 && <span className="say" style={{ background: '#0d9488' }}>{yaklasan.length}</span>}
            </button>
            {acik && (
                <div className="tkp-perde" onMouseDown={e => { if (e.target === e.currentTarget) setAcik(false); }}>
                    <div className="tkp-modal dar">
                        <div className="tkp-modal-bas">
                            <i className="fas fa-calendar-check" style={{ color: '#2dd4bf' }}></i>
                            <h5 title={ad}>Randevular — {ad}</h5>
                            <button className="tkp-kapat" onClick={() => setAcik(false)}>×</button>
                        </div>
                        <div className="tkp-modal-govde" style={{ minHeight: 150 }}>
                            {liste === null && <div style={{ textAlign: 'center', padding: 30, color: '#9ca3af' }}><i className="fas fa-spinner fa-spin"></i></div>}
                            {liste && liste.length === 0 && <div className="tkp-bos" style={{ textAlign: 'center', padding: 24 }}>Randevu yok.</div>}
                            {yaklasan.length > 0 && <div className="tkp-grup-bas">Yaklaşan ({yaklasan.length})</div>}
                            {yaklasan.map(satir)}
                            {digerleri.length > 0 && (
                                <>
                                    <div className="tkp-grup-bas" style={{ cursor: 'pointer' }} onClick={() => setGecmis(v => !v)}>
                                        <i className={`fas fa-chevron-${gecmis ? 'down' : 'right'}`}></i>Geçmiş ({digerleri.length})
                                    </div>
                                    {gecmis && digerleri.map(satir)}
                                </>
                            )}
                        </div>
                        <div className="tkp-modal-alt">
                            <button className="tkp-btn" onClick={() => setAcik(false)}>Kapat</button>
                            <button className="tkp-btn turuncu" onClick={() => setYeni(true)}><i className="fas fa-plus"></i>Yeni Randevu</button>
                        </div>
                    </div>
                </div>
            )}
            {yeni && <RandevuFormModal varsayilan={varsayilan} onKapat={() => setYeni(false)} />}
        </>
    );
};

export default KayitRandevuButonu;
